import client from "graphql/client";
import i18next from "i18next";
import { loader } from "graphql.macro";
import { BOOK_LOADED } from "redux/types";
import { snackbarSuccess, snackbarError } from "shared/redux/actions/Snackbar";
import createBookFromData from "helpers/createBookFromData";

const removeBookMeasure = loader("graphql/mutations/books/removeBookMeasure.graphql");

export default function bookMeasureRemove(osbn, measureId) {
    return async (dispatch, getState) => {
        const { current: organisation } = getState().organisation;
        dispatch(snackbarSuccess(i18next.t("books.edit.success")));

        try {
            const { data } = await client.mutate({
                mutation: removeBookMeasure,
                variables: {
                    organisationId: organisation.id,
                    osbn,
                    measureId,
                },
            });

            const { removeBookMeasure: bookData } = data;

            const book = createBookFromData(bookData);

            dispatch({
                type: BOOK_LOADED,
                id: osbn,
                book
            });
            
            dispatch(snackbarSuccess(i18next.t("books.measure.remove.success")));

        } catch (error) {
            console.error(error);
            dispatch(snackbarError(i18next.t("books.measure.remove.failed")));
        }
    };
}